import DesktopModal from './DesktopModal';

export default DesktopModal;
